module.exports = __webpack_public_path__ + "img/img1.247ec068.jpg";